(() => {
  'use strict';

  if (window.__btWatchApp) return;
  window.__btWatchApp = true;

  const root = document.querySelector('[data-bt-watch]');
  if (!root) return;

  const feed = root.querySelector('[data-bt-watch-feed]');
  const sheetWrap = root.querySelector('[data-bt-watch-sheet-wrap]');
  const sheet = root.querySelector('[data-bt-watch-sheet]');
  const toastNode = root.querySelector('[data-bt-watch-toast]');
  const API = 'https://app.btime.om';
  const isEnglish = String(root.dataset.lang || '').toLowerCase().startsWith('en');
  const tr = (ar, en) => isEnglish ? en : ar;
  const one = (selector, scope = document) => scope.querySelector(selector);
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const cartNoticeWrap = document.createElement('div');
  cartNoticeWrap.className = 'bt-watch-cart-notice-wrap';
  cartNoticeWrap.hidden = true;
  cartNoticeWrap.innerHTML = `
    <button type="button" class="bt-watch-cart-notice-backdrop" data-bt-cart-notice-close aria-label="${tr('إغلاق', 'Close')}"></button>
    <section class="bt-watch-cart-notice" role="status" aria-live="polite">
      <button type="button" class="bt-watch-cart-notice-close" data-bt-cart-notice-close aria-label="${tr('إغلاق', 'Close')}">×</button>
      <div class="bt-watch-cart-notice-title"><span><svg viewBox="0 0 24 24"><path d="m6.5 12.5 3.3 3.3L18 7.7"/></svg></span><b>${tr('تمت إضافة المنتج إلى السلة', 'Added to cart')}</b></div>
      <p data-bt-cart-notice-name></p>
      <button type="button" class="bt-watch-cart-notice-view" data-bt-cart-notice-view>
        <i></i>
        <span><svg viewBox="0 0 24 24"><path d="M3 4h2l2 11h11l2-8H6"/><circle cx="9" cy="19" r="1"/><circle cx="18" cy="19" r="1"/></svg><b data-bt-cart-notice-count></b>${tr('عرض السلة', 'View cart')}</span>
      </button>
    </section>`;
  root.appendChild(cartNoticeWrap);

  let slides = [];
  let activeIndex = 0;
  let loaded = false;
  let loadPromise = null;
  let sheetOpen = false;
  let scrollTimer = null;
  let reviewTimer = null;
  let toastTimer = null;
  let cartNoticeTimer = null;
  let sheetDrag = null;
  let soundMuted = true;

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function plainText(value) {
    const node = document.createElement('div');
    node.innerHTML = value == null ? '' : String(value);
    return String(node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function productOf(slide) {
    try {
      const product = JSON.parse(one('[data-bt-watch-product]', slide).textContent);
      product.price = plainText(product.price);
      return product;
    } catch (_) {
      return null;
    }
  }

  function productsOf(slide) {
    return slide && Array.isArray(slide._products) ? slide._products : [];
  }

  function videoOf(slide) {
    return slide ? one('.bt-watch-video', slide) : null;
  }

  function currentSlide() {
    return slides[activeIndex] || null;
  }

  function resultsUrl() {
    const url = new URL(root.dataset.url, window.location.origin);
    const current = new URLSearchParams(window.location.search);
    ['_ab', '_fd', '_sc', 'preview_theme_id'].forEach((key) => {
      if (current.has(key)) url.searchParams.set(key, current.get(key));
    });
    return url;
  }

  function compact(value) {
    const number = Number(value) || 0;
    if (number >= 1000000) return `${(number / 1000000).toFixed(number >= 10000000 ? 0 : 1)}M`;
    if (number >= 1000) return `${(number / 1000).toFixed(number >= 10000 ? 0 : 1)}K`;
    return number ? String(number) : '';
  }

  function seeded(seed, salt, min, max) {
    let hash = 2166136261;
    const input = `${seed}:${salt}`;
    for (let i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619) >>> 0;
    }
    return min + (hash % (max - min + 1));
  }

  function baseline(videoId) {
    return {
      views: seeded(videoId, 'views', 85, 260),
      likes: seeded(videoId, 'likes', 6, 24),
      favorites: 0,
      shares: seeded(videoId, 'shares', 1, 9)
    };
  }

  function renderStats(slide) {
    const stats = slide._stats || {};
    ['views', 'likes', 'favorites', 'shares'].forEach((key) => {
      const node = one(`[data-stat="${key}"]`, slide);
      if (node) node.textContent = compact(stats[key]);
    });
  }

  async function getStats(slide) {
    const id = slide.dataset.videoId || '';
    if (!id) return;
    slide._stats = baseline(id);
    renderStats(slide);
    try {
      const response = await fetch(`${API}/pro/product-videos/stats?videoId=${encodeURIComponent(id)}`, {
        headers: { Accept: 'application/json' }
      });
      const data = await response.json();
      const incoming = data.stats || {};
      ['views', 'likes', 'favorites', 'shares'].forEach((key) => {
        slide._stats[key] = Math.max(Number(slide._stats[key]) || 0, Number(incoming[key]) || 0);
      });
      renderStats(slide);
    } catch (_) {}
  }

  async function recordEvent(slide, eventName) {
    if (!slide) return;
    slide._stats = slide._stats || baseline(slide.dataset.videoId || 'video');
    const key = eventName === 'view' ? 'views' : `${eventName}s`;
    if (Object.prototype.hasOwnProperty.call(slide._stats, key)) {
      slide._stats[key] += 1;
      renderStats(slide);
    }
    try {
      const response = await fetch(`${API}/pro/product-videos/stats/event`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ videoId: slide.dataset.videoId || '', event: eventName })
      });
      const data = await response.json();
      if (data.stats) {
        ['views', 'likes', 'favorites', 'shares'].forEach((stat) => {
          slide._stats[stat] = Math.max(Number(slide._stats[stat]) || 0, Number(data.stats[stat]) || 0);
        });
        renderStats(slide);
      }
    } catch (_) {}
  }

  function normalizeGroups() {
    const groups = new Map();
    const kept = [];
    all('.bt-watch-slide', feed).forEach((slide) => {
      const product = productOf(slide);
      const group = slide.dataset.videoGroup || `media:${slide.dataset.videoId}`;
      if (groups.has(group)) {
        const primary = groups.get(group);
        if (product && !primary._products.some((item) => String(item.id) === String(product.id))) {
          primary._products.push(product);
        }
        slide.remove();
        return;
      }
      slide._products = product ? [product] : [];
      groups.set(group, slide);
      kept.push(slide);
    });

    kept
      .sort((a, b) => (Number(b.dataset.videoDate) || 0) - (Number(a.dataset.videoDate) || 0))
      .forEach((slide) => feed.appendChild(slide));

    slides = kept;
    slides.forEach((slide) => {
      const products = productsOf(slide);
      const button = one('[data-bt-products]', slide);
      if (button && products.length > 1) {
        button.hidden = false;
        one('b', button).textContent = `+${products.length}`;
      }
    });
  }

  function prepareVideo(index, preload = 'metadata') {
    const slide = slides[index];
    const video = videoOf(slide);
    if (!video) return null;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.preload = preload;
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }
    return video;
  }

  function unloadFarVideos(center) {
    slides.forEach((slide, index) => {
      if (Math.abs(index - center) <= 3) return;
      const video = videoOf(slide);
      if (!video || !video.getAttribute('src')) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
    });
  }

  function showPlay(slide, visible) {
    const button = one('[data-bt-watch-play]', slide);
    if (button) button.classList.toggle('is-visible', visible);
  }

  function updateMuteButton(slide) {
    const video = videoOf(slide);
    const button = one('[data-bt-watch-mute]', slide);
    if (!video || !button) return;
    const muted = Boolean(video.muted);
    button.classList.toggle('is-muted', muted);
    button.setAttribute('aria-label', muted ? tr('تشغيل الصوت', 'Turn sound on') : tr('كتم الصوت', 'Mute'));
    const label = one('[data-bt-mute-label]', button);
    if (label) label.textContent = muted ? tr('مكتوم', 'Muted') : tr('الصوت', 'Sound');
  }

  function playVideo(video, slide) {
    if (!video) return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.then(() => showPlay(slide, false)).catch(() => showPlay(slide, true));
    }
  }

  function activate(index, shouldPlay = true) {
    if (!slides.length) return;
    const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
    activeIndex = nextIndex;
    const slide = slides[nextIndex];
    slides.forEach((item, itemIndex) => {
      const video = videoOf(item);
      if (video && itemIndex !== nextIndex) video.pause();
    });

    const video = prepareVideo(nextIndex, 'auto');
    if (video) {
      video.muted = soundMuted;
      updateMuteButton(slide);
    }
    prepareVideo(nextIndex + 1, 'metadata');
    prepareVideo(nextIndex + 2, 'metadata');
    unloadFarVideos(nextIndex);

    if (video && shouldPlay && !sheetOpen && !root.hidden) {
      if (video.readyState >= 2) playVideo(video, slide);
      else video.addEventListener('canplay', () => playVideo(video, slide), { once: true });
    }

    if (!slide.dataset.viewed) {
      slide.dataset.viewed = 'true';
      getStats(slide);
      recordEvent(slide, 'view');
      loadReviews(slide);
    } else {
      startReviewTicker(slide);
    }
  }

  function nearestSlideIndex() {
    const feedTop = feed.getBoundingClientRect().top;
    let bestIndex = 0;
    let bestDistance = Infinity;
    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().top - feedTop);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });
    return bestIndex;
  }

  function updateProgress(video, slide) {
    const progress = one('[data-bt-watch-progress]', slide);
    if (!progress) return;
    const duration = Number(video.duration) || 0;
    const position = Number(video.currentTime) || 0;
    progress.style.width = `${duration ? Math.min(100, (position / duration) * 100) : 0}%`;
  }

  function setupSlides() {
    slides.forEach((slide, index) => {
      const video = videoOf(slide);
      if (!video) return;
      video.muted = soundMuted;
      updateMuteButton(slide);
      video.addEventListener('playing', () => showPlay(slide, false));
      video.addEventListener('pause', () => {
        if (index === activeIndex && !sheetOpen && !root.hidden) showPlay(slide, true);
      });
      video.addEventListener('timeupdate', () => updateProgress(video, slide));
      video.addEventListener('ended', () => {
        const next = slides[index + 1];
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      video.addEventListener('error', () => showPlay(slide, true));
    });

    if (slides.length) prepareVideo(0, 'auto');
    if (slides.length > 1) prepareVideo(1, 'metadata');

    feed.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => activate(nearestSlideIndex()), 90);
    }, { passive: true });
  }

  async function loadVideos() {
    if (loadPromise) return loadPromise;
    loadPromise = (async () => {
      try {
        const response = await fetch(resultsUrl(), {
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('watch-results');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = one('[data-bt-watch-results]', parsed);
        if (!results) throw new Error('watch-results');
        feed.innerHTML = results.innerHTML;
        normalizeGroups();
        setupSlides();
        loaded = true;
      } catch (_) {
        feed.innerHTML = `<div class="bt-watch-loading">${tr('تعذر تحميل الفيديوهات الآن', 'Could not load videos')}</div>`;
      }
    })();
    return loadPromise;
  }

  function openWatch() {
    root.hidden = false;
    document.body.classList.add('bt-watch-open');
    if (loaded) activate(nearestSlideIndex());
    else loadVideos().then(() => activate(0));
  }

  function closeWatch() {
    closeSheet(false);
    closeCartNotice(false);
    slides.forEach((slide) => videoOf(slide)?.pause());
    root.hidden = true;
    document.body.classList.remove('bt-watch-open');
    clearInterval(reviewTimer);
  }

  function togglePlayback(slide) {
    const video = videoOf(slide);
    if (!video) return;
    if (video.paused) playVideo(video, slide);
    else {
      video.pause();
      showPlay(slide, true);
    }
  }

  async function fetchReviews(products, limit = 6) {
    const reviews = [];
    for (const product of products.slice(0, 6)) {
      try {
        const response = await fetch(`${API}/api/bt-reviews?productId=${encodeURIComponent(product.id)}&page=1&limit=${limit}&lang=${isEnglish ? 'en' : 'ar'}`);
        const data = await response.json();
        reviews.push(...(data.reviews || []).filter((item) => String(item.comment || '').trim()));
      } catch (_) {}
    }
    const reviewTime = (value) => Number(value) || Date.parse(value) || 0;
    reviews.sort((a, b) => reviewTime(b.createdAt) - reviewTime(a.createdAt));
    return reviews.slice(0, 16);
  }

  function reviewStars(rating) {
    const value = Math.max(1, Math.min(5, Number(rating) || 5));
    return `${'★'.repeat(value)}${'☆'.repeat(5 - value)}`;
  }

  function liveReviewMarkup(review) {
    if (!review) {
      return `<span class="bt-watch-live-review-line"><b><span class="bt-watch-review-name">${tr('أضف تعليقك', 'Add your comment')}</span><span class="bt-watch-review-stars">${reviewStars(5)}</span></b><small>${tr('اكتب تقييمك للمنتج', 'Write your product review')}</small></span>`;
    }
    const rawAuthor = String(review.author || '').trim();
    const author = rawAuthor === 'عميل' || rawAuthor.toLowerCase() === 'customer' ? '' : rawAuthor;
    return `<span class="bt-watch-live-review-line"><b><span class="bt-watch-review-name">${escapeHtml(author || tr('زائر', 'Guest'))}</span><span class="bt-watch-review-stars">${reviewStars(review.rating)}</span></b><small>${escapeHtml(review.comment)}</small></span>`;
  }

  function drawLiveReview(slide) {
    const host = one('[data-bt-live-review]', slide);
    if (!host) return;
    const reviews = slide._reviews || [];
    if (!reviews.length) {
      host.hidden = false;
      if (!one('.bt-watch-live-review-line', host)) host.insertAdjacentHTML('beforeend', liveReviewMarkup(null));
      return;
    }
    const review = reviews[slide._reviewIndex % reviews.length];
    slide._reviewIndex = (slide._reviewIndex + 1) % reviews.length;
    host.hidden = false;
    const current = one('.bt-watch-live-review-line:not(.is-exiting)', host);
    if (current) {
      current.classList.add('is-exiting');
      window.setTimeout(() => current.remove(), 700);
    }
    host.insertAdjacentHTML('beforeend', liveReviewMarkup(review));
  }

  function startReviewTicker(slide) {
    clearInterval(reviewTimer);
    if (!slide) return;
    drawLiveReview(slide);
    if ((slide._reviews || []).length > 1) {
      reviewTimer = setInterval(() => drawLiveReview(slide), 2700);
    }
  }

  async function loadReviews(slide) {
    if (slide._reviewsLoaded) {
      startReviewTicker(slide);
      return;
    }
    slide._reviewsLoaded = true;
    slide._reviewIndex = 0;
    slide._reviews = await fetchReviews(productsOf(slide));
    const allRatings = slide._reviews.map((item) => Number(item.rating) || 0).filter(Boolean);
    const ratingNode = one('[data-bt-brand-rating]', slide);
    if (ratingNode && allRatings.length) {
      const average = allRatings.reduce((sum, value) => sum + value, 0) / allRatings.length;
      ratingNode.textContent = `★ ${average.toFixed(1)} (${allRatings.length})`;
    }
    if (currentSlide() === slide) startReviewTicker(slide);
  }

  function pauseForSheet() {
    sheetOpen = true;
    clearInterval(reviewTimer);
    videoOf(currentSlide())?.pause();
  }

  function showSheet(html, ready, variant = '') {
    pauseForSheet();
    resetSheetPosition();
    sheet.className = `bt-watch-sheet${variant ? ` ${variant}` : ''}`;
    sheet.innerHTML = `<div class="bt-watch-sheet-handle"></div>${html}`;
    sheetWrap.hidden = false;
    if (typeof ready === 'function') ready();
  }

  function resetSheetPosition(animate = false) {
    const backdrop = one('[data-bt-watch-sheet-close]', sheetWrap);
    sheetDrag = null;
    sheet.classList.remove('is-dragging');
    if (animate) {
      sheet.style.transition = 'transform .22s ease-out';
      sheet.style.transform = 'translateY(0)';
      if (backdrop) {
        backdrop.style.transition = 'opacity .22s ease-out';
        backdrop.style.opacity = '1';
      }
      window.setTimeout(() => {
        sheet.style.removeProperty('transition');
        sheet.style.removeProperty('transform');
        if (backdrop) {
          backdrop.style.removeProperty('transition');
          backdrop.style.removeProperty('opacity');
        }
      }, 230);
      return;
    }
    sheet.style.removeProperty('transition');
    sheet.style.removeProperty('transform');
    if (backdrop) {
      backdrop.style.removeProperty('transition');
      backdrop.style.removeProperty('opacity');
    }
  }

  function bindSheetDrag() {
    const backdrop = one('[data-bt-watch-sheet-close]', sheetWrap);
    const finishDrag = (event) => {
      if (!sheetDrag || event.pointerId !== sheetDrag.pointerId) return;
      const drag = sheetDrag;
      const elapsed = Math.max(16, performance.now() - drag.startedAt);
      const velocity = Math.max(0, drag.distance) / elapsed;
      sheetDrag = null;
      try { drag.handle.releasePointerCapture(event.pointerId); } catch (_) {}
      if (drag.distance > 72 || velocity > 0.55) {
        sheet.classList.remove('is-dragging');
        sheet.style.transition = 'transform .2s ease-in';
        sheet.style.transform = 'translateY(105%)';
        if (backdrop) {
          backdrop.style.transition = 'opacity .2s ease-in';
          backdrop.style.opacity = '0';
        }
        window.setTimeout(() => closeSheet(), 190);
      } else {
        resetSheetPosition(true);
      }
    };

    sheet.addEventListener('pointerdown', (event) => {
      const handle = event.target.closest('.bt-watch-sheet-handle');
      if (!handle || event.button > 0 || sheetDrag) return;
      sheetDrag = {
        pointerId: event.pointerId,
        handle,
        startY: event.clientY,
        distance: 0,
        startedAt: performance.now()
      };
      sheet.classList.add('is-dragging');
      sheet.style.transition = 'none';
      handle.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    });

    sheet.addEventListener('pointermove', (event) => {
      if (!sheetDrag || event.pointerId !== sheetDrag.pointerId) return;
      const distance = Math.max(0, event.clientY - sheetDrag.startY);
      sheetDrag.distance = distance;
      sheet.style.transform = `translateY(${distance}px)`;
      if (backdrop) backdrop.style.opacity = String(Math.max(.18, 1 - (distance / Math.max(220, sheet.offsetHeight))));
      event.preventDefault();
    });
    sheet.addEventListener('pointerup', finishDrag);
    sheet.addEventListener('pointercancel', finishDrag);
  }

  function closeSheet(resume = true) {
    if (!sheetWrap || sheetWrap.hidden) return;
    resetSheetPosition();
    sheetWrap.hidden = true;
    sheet.innerHTML = '';
    sheet.className = 'bt-watch-sheet';
    sheetOpen = false;
    if (resume && !root.hidden) activate(activeIndex);
  }

  function optionValue(value) {
    return typeof value === 'string' ? value : String(value?.name || value?.value || value || '');
  }

  function variantId(variant) {
    return String(variant?.id || '').split('/').pop();
  }

  function availableVariant(product, selectedValues) {
    const variants = product.variants || [];
    if (selectedValues?.length) {
      const match = variants.find((variant) => (variant.options || []).every((value, index) => String(value) === String(selectedValues[index])));
      if (match?.available) return match;
    }
    return variants.find((variant) => variant.available) || variants[0];
  }

  async function cartCount() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) return Number((await response.json()).item_count) || 0;
    } catch (_) {}
    return 0;
  }

  function closeCartNotice(resume = true) {
    if (cartNoticeWrap.hidden) return;
    clearTimeout(cartNoticeTimer);
    cartNoticeWrap.hidden = true;
    cartNoticeWrap.classList.remove('is-open');
    sheetOpen = false;
    if (resume && !root.hidden) activate(activeIndex);
  }

  function showCartNotice(productName, count) {
    closeSheet(false);
    pauseForSheet();
    one('[data-bt-cart-notice-name]', cartNoticeWrap).textContent = productName || '';
    const badge = one('[data-bt-cart-notice-count]', cartNoticeWrap);
    badge.textContent = count > 0 ? String(count) : '';
    badge.hidden = count < 1;
    cartNoticeWrap.hidden = false;
    cartNoticeWrap.classList.remove('is-open');
    void cartNoticeWrap.offsetWidth;
    cartNoticeWrap.classList.add('is-open');
    clearTimeout(cartNoticeTimer);
    cartNoticeTimer = window.setTimeout(() => closeCartNotice(), 2600);
  }

  async function addCartItems(items, button, noticeName = '') {
    const valid = items.filter((item) => item.id && item.quantity > 0);
    if (!valid.length || button?.disabled) return false;
    const iconButton = button?.matches('[data-bt-watch-cart]');
    if (button) {
      button.disabled = true;
      if (iconButton) button.classList.add('is-loading');
      else button.textContent = tr('جاري الإضافة…', 'Adding…');
    }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: valid })
      });
      if (!response.ok) throw new Error('cart');
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'bt-watch', actionAfterATC: 'stay' }
      }));
      const count = await cartCount();
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (!iconButton) button.textContent = `✓ ${tr('تمت الإضافة', 'Added')}`;
      }
      showCartNotice(noticeName, count);
      return true;
    } catch (_) {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (!iconButton) button.textContent = tr('تعذر الإضافة، حاول مجددًا', 'Could not add, try again');
      }
      toast(tr('تعذر الإضافة، حاول مجددًا', 'Could not add, try again'));
      return false;
    }
  }

  function openProductSheet(product) {
    const allOptions = product.options || [];
    const selected = allOptions.map((option) => optionValue((option.values || [])[0]));
    const options = allOptions.map((option, optionIndex) => ({ option, optionIndex })).filter(({ option }) => {
      const name = String(option.name || '').trim().toLowerCase();
      const values = (option.values || []).map(optionValue);
      return !(name === 'title' && values.length === 1 && /^default title$/i.test(values[0]));
    });
    const optionsHtml = options.map(({ option, optionIndex }) => {
      const values = (option.values || []).map(optionValue);
      return `<fieldset data-option-index="${optionIndex}"><legend>${escapeHtml(option.name)}</legend>${values.map((value, valueIndex) => `<button type="button" class="${valueIndex === 0 ? 'is-selected' : ''}" data-option-value="${escapeHtml(value)}">${escapeHtml(value)}</button>`).join('')}</fieldset>`;
    }).join('');

    showSheet(`
      <div class="bt-watch-sheet-product"><img src="${escapeHtml(product.image)}" alt=""><div><strong>${escapeHtml(product.title)}</strong><b>${escapeHtml(product.price)}</b></div></div>
      ${optionsHtml}
      <div class="bt-watch-qty"><button type="button" data-qty-minus>−</button><b data-qty>1</b><button type="button" data-qty-plus>+</button></div>
      <button type="button" class="bt-watch-sheet-add" data-add-product>${tr('إضافة إلى السلة', 'Add to cart')}</button>
    `, () => {
      all('[data-option-index]', sheet).forEach((fieldset) => {
        all('[data-option-value]', fieldset).forEach((button) => {
          button.addEventListener('click', () => {
            const index = Number(fieldset.dataset.optionIndex);
            selected[index] = button.dataset.optionValue;
            all('[data-option-value]', fieldset).forEach((item) => item.classList.toggle('is-selected', item === button));
          });
        });
      });
      const quantity = one('[data-qty]', sheet);
      one('[data-qty-minus]', sheet).onclick = () => { quantity.textContent = String(Math.max(1, Number(quantity.textContent) - 1)); };
      one('[data-qty-plus]', sheet).onclick = () => { quantity.textContent = String(Math.min(20, Number(quantity.textContent) + 1)); };
      one('[data-add-product]', sheet).onclick = () => {
        const variant = availableVariant(product, selected);
        addCartItems([{ id: Number(variantId(variant)), quantity: Number(quantity.textContent) }], one('[data-add-product]', sheet), product.title);
      };
    });
  }

  function openProductsSheet(slide) {
    const products = productsOf(slide);
    showSheet(`
      <h3><span>${tr('منتجات الفيديو', 'Video products')}</span><small>+${products.length}</small></h3>
      <div class="bt-watch-products-list">${products.map((product, index) => `<button type="button" data-product-index="${index}"><img src="${escapeHtml(product.image)}" alt=""><span><b>${escapeHtml(product.title)}</b>${product.description ? `<small>${escapeHtml(product.description)}</small>` : ''}<em>${escapeHtml(product.price)}</em></span><i>${isEnglish ? '›' : '‹'}</i></button>`).join('')}</div>
    `, () => {
      all('[data-product-index]', sheet).forEach((button) => {
        button.onclick = () => { window.location.href = products[Number(button.dataset.productIndex)].url; };
      });
    }, 'bt-watch-sheet--products');
  }

  async function openReviewSheet(slide) {
    const product = productsOf(slide)[0];
    if (!product) return;
    showSheet(`
      <h3>${tr('أضف تعليقك', 'Add comment')}</h3>
      <form class="bt-watch-review-form" data-review-form>
        <div class="bt-watch-stars" role="radiogroup" aria-label="${tr('اختر عدد النجوم', 'Choose star rating')}">${[1,2,3,4,5].map((value) => `<button type="button" class="is-selected" data-rating="${value}" aria-label="${value} ${tr('نجوم', 'stars')}">★</button>`).join('')}</div>
        <textarea name="comment" required placeholder="${tr('اكتب رأيك عن المنتج', 'Write your product review')}"></textarea>
        <input type="hidden" name="author" value="${escapeHtml(root.dataset.customerName || tr('زائر', 'Guest'))}">
        <input type="hidden" name="email" value="${escapeHtml(root.dataset.customerEmail || '')}">
        <input type="hidden" name="rating" value="5">
        <button type="submit" class="bt-watch-sheet-add bt-watch-review-submit"><span><svg viewBox="0 0 24 24"><path d="M4 4h16v13H9l-5 4V4Z"/><path d="m12 7 .9 1.9 2.1.3-1.5 1.5.4 2.1-1.9-1-1.9 1 .4-2.1-1.5-1.5 2.1-.3L12 7Z"/></svg></span><b data-review-submit-label>${tr('إرسال', 'Submit')}</b></button>
        <p class="bt-watch-review-status" data-review-status></p>
      </form>
    `, () => {
      all('[data-rating]', sheet).forEach((button) => {
        button.onclick = () => {
          const rating = Number(button.dataset.rating);
          one('[name="rating"]', sheet).value = String(rating);
          all('[data-rating]', sheet).forEach((item) => item.classList.toggle('is-selected', Number(item.dataset.rating) <= rating));
        };
      });
      one('[data-review-form]', sheet).onsubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const button = one('[type="submit"]', form);
        const label = one('[data-review-submit-label]', button);
        const status = one('[data-review-status]', form);
        const data = new FormData(form);
        data.set('productId', product.id);
        data.set('productName', product.title);
        data.set('lang', isEnglish ? 'en' : 'ar');
        if (!String(data.get('author') || '').trim()) data.set('author', tr('زائر', 'Guest'));
        button.disabled = true;
        button.classList.add('is-loading');
        label.textContent = tr('جاري الإرسال…', 'Submitting…');
        status.textContent = tr('جاري الإرسال…', 'Submitting…');
        try {
          const response = await fetch(`${API}/api/bt-reviews?lang=${isEnglish ? 'en' : 'ar'}`, { method: 'POST', body: data });
          const result = await response.json();
          if (!response.ok || result.ok === false) throw new Error(result.error || 'review');
          slide._reviews = await fetchReviews(productsOf(slide), 12);
          slide._reviewsLoaded = true;
          slide._reviewIndex = 0;
          toast(tr('شكرًا، تم إرسال تقييمك.', 'Thank you. Your review was submitted.'));
          closeSheet();
        } catch (error) {
          status.textContent = error.message && error.message !== 'review' ? error.message : tr('تعذر إرسال التقييم.', 'Could not submit the review.');
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
          label.textContent = tr('إرسال', 'Submit');
        }
      };
    }, 'bt-watch-sheet--review');
  }

  function openInfoSheet(product) {
    showSheet(`
      <div class="bt-watch-sheet-product"><img src="${escapeHtml(product.image)}" alt=""><div><strong>${escapeHtml(product.title)}</strong><b>${escapeHtml(product.price)}</b></div></div>
      <div class="bt-watch-description"><p>${escapeHtml(product.description || '')}</p></div>
      <button type="button" class="bt-watch-sheet-add" data-open-product>${tr('عرض المنتج', 'View product')}</button>
    `, () => {
      one('[data-open-product]', sheet).onclick = () => { window.location.href = product.url; };
    });
  }

  function syncFavorite(slide) {
    const button = one('[data-bt-watch-favorite]', slide);
    const nativeButton = one('[data-bt-watch-native-wishlist]', slide);
    if (!button) return;
    const action = nativeButton?.getAttribute('action');
    button.classList.toggle('is-active', action === 'remove' || action === 'added');
    button.toggleAttribute('aria-busy', nativeButton?.getAttribute('aria-busy') === 'true');
  }

  function setupFavoriteSync(slide) {
    const nativeButton = one('[data-bt-watch-native-wishlist]', slide);
    if (nativeButton) {
      new MutationObserver(() => syncFavorite(slide)).observe(nativeButton, {
        attributes: true,
        attributeFilter: ['action', 'aria-busy']
      });
    }
    syncFavorite(slide);
  }

  async function toggleFavorite(slide) {
    const product = productsOf(slide)[0];
    const button = one('[data-bt-watch-favorite]', slide);
    const nativeButton = one('[data-bt-watch-native-wishlist]', slide);
    const loginLink = one('[data-bt-watch-wishlist-login]', slide);
    if (!product || !button) return;

    if (nativeButton) {
      if (!customElements.get('hdt-wishlist')) await customElements.whenDefined('hdt-wishlist');
      const wasActive = ['remove', 'added'].includes(nativeButton.getAttribute('action'));
      nativeButton.click();
      if (!wasActive) recordEvent(slide, 'favorite');
      requestAnimationFrame(() => syncFavorite(slide));
      setTimeout(() => syncFavorite(slide), 350);
      return;
    }

    if (loginLink) loginLink.click();
  }

  function shareUrlForProducts(products, fallback) {
    if (products.length <= 1) return fallback;
    const variantIds = products
      .map((product) => variantId(availableVariant(product)))
      .filter((id) => id);
    if (!variantIds.length || variantIds.length !== products.length) return fallback;
    const cartItems = variantIds.map((id) => `${id}:1`).join(',');
    return `${window.location.origin}/cart/${cartItems}`;
  }

  async function shareSlide(slide) {
    const products = productsOf(slide);
    const product = products[0];
    if (!product) return;
    recordEvent(slide, 'share');
    const fallbackUrl = new URL(product.url, window.location.origin).href;
    const data = {
      title: product.title,
      text: product.description,
      url: shareUrlForProducts(products, fallbackUrl)
    };
    try {
      if (navigator.share) await navigator.share(data);
      else {
        await navigator.clipboard.writeText(data.url);
        toast(tr('تم نسخ الرابط', 'Link copied'));
      }
    } catch (_) {}
  }

  function toast(message) {
    clearTimeout(toastTimer);
    toastNode.textContent = message;
    toastNode.hidden = false;
    toastTimer = setTimeout(() => { toastNode.hidden = true; }, 1800);
  }

  root.addEventListener('click', (event) => {
    const slide = event.target.closest('.bt-watch-slide');
    if (event.target.closest('[data-bt-watch-close]')) return closeWatch();
    if (event.target.closest('[data-bt-cart-notice-close]')) return closeCartNotice();
    if (event.target.closest('[data-bt-cart-notice-view]')) {
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      return;
    }
    if (event.target.closest('[data-bt-watch-sheet-close]')) return closeSheet();
    if (!slide) return;

    if (event.target.closest('.bt-watch-video') || event.target.closest('[data-bt-watch-play]')) return togglePlayback(slide);
    if (event.target.closest('[data-bt-product-card]')) {
      const product = productsOf(slide)[0];
      if (product) window.location.href = product.url;
      return;
    }
    if (event.target.closest('[data-bt-products]')) return openProductsSheet(slide);
    if (event.target.closest('[data-bt-live-review]') || event.target.closest('[data-bt-watch-comments]')) return openReviewSheet(slide);
    if (event.target.closest('[data-bt-watch-mute]')) {
      const video = videoOf(slide);
      soundMuted = !soundMuted;
      slides.forEach((item) => {
        const itemVideo = videoOf(item);
        if (itemVideo) itemVideo.muted = soundMuted;
        updateMuteButton(item);
      });
      playVideo(video, slide);
      return;
    }
    if (event.target.closest('[data-bt-watch-like]')) {
      const button = event.target.closest('[data-bt-watch-like]');
      if (!button.classList.contains('is-active')) {
        button.classList.add('is-active');
        recordEvent(slide, 'like');
      }
      return;
    }
    if (event.target.closest('[data-bt-watch-favorite]')) return toggleFavorite(slide);
    if (event.target.closest('[data-bt-watch-cart]')) {
      const products = productsOf(slide);
      const available = products.filter((product) => product.available !== false);
      const items = available.map((product) => ({ id: Number(variantId(availableVariant(product))), quantity: 1 })).filter((item) => item.id);
      const noticeName = available.length > 1
        ? tr(`تمت إضافة ${available.length} منتجات من الفيديو`, `${available.length} video products added`)
        : (available[0]?.title || '');
      return addCartItems(items, event.target.closest('[data-bt-watch-cart]'), noticeName);
    }
    if (event.target.closest('[data-bt-watch-share]')) return shareSlide(slide);
    if (event.target.closest('[data-bt-watch-info]')) return openInfoSheet(productsOf(slide)[0]);
  });

  bindSheetDrag();

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-bt-watch-open]')) openWatch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || root.hidden) return;
    if (sheetOpen) closeSheet();
    else closeWatch();
  });

  document.addEventListener('visibilitychange', () => {
    const video = videoOf(currentSlide());
    if (!video) return;
    if (document.hidden) video.pause();
    else if (!root.hidden && !sheetOpen) playVideo(video, currentSlide());
  });

  document.addEventListener('theme4:wishlist:update', () => slides.forEach(syncFavorite));
  loadVideos().then(() => slides.forEach(setupFavoriteSync));
})();
